module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "logo"
  }), _vm._v(" "), _c('div', {
    staticClass: "content resetpwd"
  }, [_c('div', {
    staticClass: "title font-size24 color-msg"
  }, [_vm._v("重置密码")]), _vm._v(" "), _c('div', {
    staticClass: "font-size14 color-msg cue"
  }, [_vm._v("请重设您的帐号密码")]), _vm._v(" "), _c('div', {
    staticClass: "ipt-box font-size14"
  }, [_c('div', {
    staticClass: "account-ipt"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pwd),
      expression: "pwd"
    }],
    staticClass: "input",
    attrs: {
      "placeholder": "新密码",
      "type": "password"
    },
    domProps: {
      "value": (_vm.pwd)
    },
    on: {
      "focus": _vm.pwdFocus,
      "blur": _vm.pwdBlur,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pwd = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pwdData.errMsgShow && !_vm.isMobile),
      expression: "pwdData.errMsgShow&&!isMobile"
    }],
    staticClass: "msg-box"
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "text color-msg font-size12"
  }, [_vm._v(_vm._s(_vm.pwdData.errMsg))])])]), _vm._v(" "), _c('div', {
    staticClass: "account-ipt"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.repwd),
      expression: "repwd"
    }],
    staticClass: "input",
    attrs: {
      "placeholder": "确认新密码",
      "type": "password"
    },
    domProps: {
      "value": (_vm.repwd)
    },
    on: {
      "focus": _vm.repwdFocus,
      "blur": _vm.repwdBlur,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.repwd = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.repwdData.errMsgShow && !_vm.isMobile),
      expression: "repwdData.errMsgShow&&!isMobile"
    }],
    staticClass: "msg-box"
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "text color-msg font-size12"
  }, [_vm._v(_vm._s(_vm.repwdData.errMsg))])])]), _vm._v(" "), _c('div', {
    staticClass: "font-size14 color-msg bottom-cue"
  }, [_vm._v("密码长度6-20位，数字、字母、_至少包含两种")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.submitBtnState == _vm.CONF.submitBtnState.enable),
      expression: " submitBtnState==CONF.submitBtnState.enable"
    }],
    staticClass: "account-btn",
    on: {
      "click": _vm.resetPwd
    }
  }, [_vm._v("确 定")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.submitBtnState == _vm.CONF.submitBtnState.disable),
      expression: " submitBtnState==CONF.submitBtnState.disable"
    }],
    staticClass: "account-btn disable"
  }, [_vm._v("确 定")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-172b0e88","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/ResetSetPwd.vue
// module id = 130
// module chunks = 1